import { useFaust } from "../../contexts/FaustContext";
import { Button } from "../ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";
import { Volume2, VolumeX } from "lucide-react";
import { cn } from "../../lib/utils";

export function OutputButton() {
    const { state, toggleOutput } = useFaust();

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <Button
                    variant={state.outputEnabled ? "default" : "outline"}
                    className={cn(
                        "w-full h-9 gap-2 font-medium transition-all duration-200",
                        state.outputEnabled
                            ? "bg-[#0078d4] hover:bg-[#0078d4]/90 text-white border-[#0078d4] shadow-lg shadow-[#0078d4]/20"
                            : "border-white/[0.08] text-[#8b949e] hover:text-[#cccccc] hover:border-white/[0.12]"
                    )}
                    onClick={toggleOutput}
                >
                    {state.outputEnabled ? (
                        <>
                            <Volume2 className="h-4 w-4" />
                            <span className="text-xs">Output is On</span>
                        </>
                    ) : (
                        <>
                            <VolumeX className="h-4 w-4" />
                            <span className="text-xs">Output is Off</span>
                        </>
                    )}
                </Button>
            </TooltipTrigger>
            <TooltipContent side="left">Toggle audio output</TooltipContent>
        </Tooltip>
    );
}
